// extracted by mini-css-extract-plugin
export default {"container":"Hero1_container__6Sefx","linkstyle":"Hero1_linkstyle__mHDwE","head":"Hero1_head__Cc3At","text":"Hero1_text__8NMon","btn":"Hero1_btn__hB1y2"};